import React from 'react';

import ColumnDropdownSelector, {
  ColumnDropdownSelectorFilterOptions,
} from 'data-frames/column-selector/ColumnDropdownSelector';
import {GetPipelineConfigSpecType} from 'pipelines/StepShapeUtils';
import DataTestAttrs from 'test/lib/cypress/shared/DataTestAttrs';
import {ButtonSize} from 'ui-library/buttons/Button';
import {CornerRadius} from 'ui-library/dropdowns/SelectDropdown';

import {getDataFrameInfoOrEmptyInfo, useStepConfigEditorContext} from '../StepConfigEditorContext';

interface ColumnReferenceProps {
  config: string | null;
  onChangeConfig: (config: string | null) => void;
  configShape: GetPipelineConfigSpecType<'columnReference'>;
  dataTestAttrs?: DataTestAttrs;
  disabled?: boolean;
  buttonSize?: ButtonSize;
  cornerRadius?: CornerRadius;
  noColumnSelectedText?: string;
  allowSelectNull?: boolean;
  filterOptions?: ColumnDropdownSelectorFilterOptions;
  renderCyclingSelector?: boolean;
}

export default function ColumnReferenceEditor({
  config,
  onChangeConfig,
  configShape,
  dataTestAttrs,
  disabled,
  cornerRadius,
  buttonSize = ButtonSize.MEDIUM,
  noColumnSelectedText = 'Select column',
  allowSelectNull = false,
  filterOptions = undefined,
  renderCyclingSelector = false,
}: ColumnReferenceProps): JSX.Element {
  const {dataFramesInfos} = useStepConfigEditorContext();
  const {dataFrameSpec} = getDataFrameInfoOrEmptyInfo(dataFramesInfos, configShape.inputDataName);
  return (
    <ColumnDropdownSelector
      dataFrameSpec={dataFrameSpec}
      dataTestAttrs={dataTestAttrs}
      onChange={onChangeConfig}
      selectedColumnSystemName={config}
      validationOptions={configShape.validationOptions ?? undefined}
      buttonSize={buttonSize}
      noColumnSelectedText={noColumnSelectedText}
      allowSelectNull={allowSelectNull}
      disabled={disabled}
      cornerRadius={cornerRadius}
      filterOptions={filterOptions}
      renderCyclingSelector={renderCyclingSelector}
      displayMissingColumnName={true}
    />
  );
}
